export const colors = {
  white: "#fff",
  gray: "#eaeaea",
  black: "#2B2B2B",
  dark: "#292D41",
  darkRgba15: "rgba(41,45,65, 0.15)",
  darkRgba25: "rgba(41,45,65, 0.25)",
  darkRgba8: "rgba(41,45,65, 0.08)",
  darkRgba5: "rgba(41,45,65, 0.05)",
  blueDark: "#43475C",
  green: "#27ae60",
  blue: "#1976D2",
  red: "#ec1751",
};

export const colorScheme = {
  primary: colors.blue,
  secondary: colors.blueDark,
  warning: colors.blue,
  text: colors.dark,
};
